/**
 * The kitchen's combined count (owner, 2026-10-25: "sometimes we have 3-4 dal
 * tadka in separate KOTs ... on top we should be able to see total items in one
 * go"). Every item still on the board, added up across KOTs.
 *
 * Same dish, same size and add-ons, same note = one line. A note stays its own
 * line: "less spicy" is cooked differently and must not vanish into the total.
 * Quantities add at tenths so 0.5 + 1.5 is exactly 2.
 */
const detailOf = item => [item.variation_name, ...(item.modifier_names || [])].filter(Boolean).join(" · ");

export function combineItems(tickets) {
  const lines = new Map();
  for (const ticket of tickets || []) {
    for (const item of ticket.items || []) {
      const detail = detailOf(item);
      const note = (item.notes || "").trim();
      const key = [item.item_name, detail, note].filter(Boolean).join(" | ");
      const line = lines.get(key) || { key, name: item.item_name, detail, note, tenths: 0, ticketKeys: new Set() };
      line.tenths += Math.round(Number(item.quantity || 0) * 10);
      line.ticketKeys.add(ticket.key);
      lines.set(key, line);
    }
  }
  return [...lines.values()]
    .map(({ tenths, ticketKeys, ...line }) => ({ ...line, quantity: tenths / 10, tickets: ticketKeys.size }))
    .sort((a, b) => b.quantity - a.quantity || b.tickets - a.tickets || a.name.localeCompare(b.name));
}
